import firebase from "firebase";
import "firebase/messaging";
import "firebase/analytics";

const config = {
  apiKey: "AIzaSyDN2OYiQh0ZZiDTcqiQ1sIVY7JDOVVugBE",
  authDomain: "charactercount-797c3.firebaseapp.com",
  databaseURL: "https://charactercount-797c3.firebaseio.com",
  projectId: "charactercount-797c3",
  storageBucket: "charactercount-797c3.appspot.com",
  messagingSenderId: "366005571569",
  appId: "1:366005571569:web:da62005345d38022767e50",
  measurementId: "G-LGF72TB8SE",
};

firebase.initializeApp(config);
firebase.analytics();
// const messaging = firebase.messaging();
// messaging.getToken({
//   vapidKey:
//     "BOLcxJiaJNTXEIt9gAUjpAk8SAjwxUV2y_5wo8gIaqiVaaUTQigox2VblKEvJzUxGo79sE15dHbCLZLyk8PEoUQ",
// });
